// Keyless, CORS-enabled geocoding via Photon (Komoot). India-biased.
const PHOTON = "https://photon.komoot.io";
const BIAS = "&lat=22.3511&lon=78.6677";

// Major Indian cities — used as instant suggestions and always matched first in search.
export const CITY_PRESETS = [
  { display_name: "Mumbai, Maharashtra", lat: 19.076, lon: 72.8777, place_id: "city-mumbai" },
  { display_name: "Delhi", lat: 28.6139, lon: 77.209, place_id: "city-delhi" },
  { display_name: "Bengaluru, Karnataka", lat: 12.9716, lon: 77.5946, place_id: "city-bengaluru" },
  { display_name: "Hyderabad, Telangana", lat: 17.385, lon: 78.4867, place_id: "city-hyderabad" },
  { display_name: "Chennai, Tamil Nadu", lat: 13.0827, lon: 80.2707, place_id: "city-chennai" },
  { display_name: "Kolkata, West Bengal", lat: 22.5726, lon: 88.3639, place_id: "city-kolkata" },
  { display_name: "Pune, Maharashtra", lat: 18.5204, lon: 73.8567, place_id: "city-pune" },
  { display_name: "Ahmedabad, Gujarat", lat: 23.0225, lon: 72.5714, place_id: "city-ahmedabad" },
  { display_name: "Jaipur, Rajasthan", lat: 26.9124, lon: 75.7873, place_id: "city-jaipur" },
  { display_name: "Surat, Gujarat", lat: 21.1702, lon: 72.8311, place_id: "city-surat" },
  { display_name: "Lucknow, Uttar Pradesh", lat: 26.8467, lon: 80.9462, place_id: "city-lucknow" },
  { display_name: "Kanpur, Uttar Pradesh", lat: 26.4499, lon: 80.3319, place_id: "city-kanpur" },
  { display_name: "Nagpur, Maharashtra", lat: 21.1458, lon: 79.0882, place_id: "city-nagpur" },
  { display_name: "Indore, Madhya Pradesh", lat: 22.7196, lon: 75.8577, place_id: "city-indore" },
  { display_name: "Bhopal, Madhya Pradesh", lat: 23.2599, lon: 77.4126, place_id: "city-bhopal" },
  { display_name: "Patna, Bihar", lat: 25.5941, lon: 85.1376, place_id: "city-patna" },
  { display_name: "Kochi, Kerala", lat: 9.9312, lon: 76.2673, place_id: "city-kochi" },
  { display_name: "Visakhapatnam, Andhra Pradesh", lat: 17.6868, lon: 83.2185, place_id: "city-visakhapatnam" },
  { display_name: "Vijayawada, Andhra Pradesh", lat: 16.5062, lon: 80.648, place_id: "city-vijayawada" },
  { display_name: "Guntur, Andhra Pradesh", lat: 16.3067, lon: 80.4365, place_id: "city-guntur" },
  { display_name: "Tirupati, Andhra Pradesh", lat: 13.6288, lon: 79.4192, place_id: "city-tirupati" },
  { display_name: "Anantapur, Andhra Pradesh", lat: 14.6819, lon: 77.6006, place_id: "city-anantapur" },
  { display_name: "Goa (Panaji)", lat: 15.4909, lon: 73.8278, place_id: "city-goa" },
  { display_name: "Coimbatore, Tamil Nadu", lat: 11.0168, lon: 76.9558, place_id: "city-coimbatore" },
  { display_name: "Mysuru, Karnataka", lat: 12.2958, lon: 76.6394, place_id: "city-mysuru" },
  { display_name: "Madurai, Tamil Nadu", lat: 9.9252, lon: 78.1198, place_id: "city-madurai" },
  { display_name: "Nashik, Maharashtra", lat: 19.9975, lon: 73.7898, place_id: "city-nashik" },
];

function fmt(p = {}) {
  const parts = [p.name, p.street, p.district, p.city, p.county, p.state, p.country];
  return [...new Set(parts.filter(Boolean))].join(", ");
}

export async function searchPlaces(q) {
  // Always surface matching major cities at the top, then geocoder results.
  const ql = q.toLowerCase();
  const presetHits = CITY_PRESETS.filter((c) => c.display_name.toLowerCase().includes(ql));
  try {
    const res = await fetch(`${PHOTON}/api/?q=${encodeURIComponent(q)}&limit=10&lang=en${BIAS}`);
    const data = await res.json();
    const results = (data.features || [])
      .map((f, i) => ({
        place_id: f.properties?.osm_id ? `${f.properties.osm_type || ""}${f.properties.osm_id}` : `p${i}`,
        display_name: fmt(f.properties),
        lat: f.geometry.coordinates[1],
        lon: f.geometry.coordinates[0],
      }))
      .filter((r) => r.display_name);
    const seen = new Set(results.map((r) => r.display_name));
    return [...presetHits.filter((c) => !seen.has(c.display_name)), ...results];
  } catch {
    return presetHits;
  }
}

export async function reversePlace(lat, lng) {
  const res = await fetch(`${PHOTON}/reverse?lon=${lng}&lat=${lat}&lang=en`);
  const data = await res.json();
  const f = data.features && data.features[0];
  return f ? fmt(f.properties) : null;
}
